import React, { Component, ReactNode, ErrorInfo } from 'react';
import { connect } from 'react-redux';
import { userId as userIdSelector } from 'ggApp/modules/auth/selectors';

import { ErrorScreen } from './styles';

const reportingEnvironments = new Set(['staging', 'production']);

type DashboardErrorBoundaryProps = {
    children: ReactNode;
};

type EnhancedProps = {
    userId?: number;
};

type DashboardErrorBoundaryState = {
    hasError: boolean;
};

class DashboardErrorBoundary extends Component<
    DashboardErrorBoundaryProps & EnhancedProps,
    DashboardErrorBoundaryState
> {
    constructor(props: DashboardErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // eslint-disable-next-line no-console
        console.error(error, errorInfo);

        this.setState({
            hasError: true,
        });
    }

    render(): JSX.Element | ReactNode {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return <ErrorScreen hasButton={false} />;
        }

        return children;
    }
}

const enhance = connect<EnhancedProps, {}, DashboardErrorBoundaryProps>((state) => ({
    userId: userIdSelector(state),
}));

export default enhance(DashboardErrorBoundary);
